export default __webpack_public_path__ + "static/media/wTop_1_c2.33ce8ffc.jpeg";